// @flow

import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import R from 'ramda';

import PartnerCard from './PartnerCard';
import {
  CHANNEL_LEVEL_SETTINGS,
  WRITE_PERMISSION
} from '../../../common/support/accessControlConstants';
import { AccessIconButton } from '../../../common/components/AccessControl';
import { isAdPartnerVisible } from '../../../main/screens/ScreenAdPartner/selectors';

import type { AdPartner } from '../../../main/types/adPartnerTypes';

type Props = {
  scrollTop?: boolean,
  showAllPartners?: boolean,
  data: Array<AdPartner>,
  enabledText?: string,
  disabledText?: string,
  showAddPartner?: boolean,
  selectedPartner?: AdPartner | null,
  accessResources?: Array<string>,
  permission?: number,
  onClick: (partner: AdPartner) => void,
  onDisableClick?: (partner: AdPartner) => void,
  loading?: boolean | null
};

class PartnerList extends PureComponent<Props> {
  static defaultProps = {
    data: [],
    scrollTop: false,
    showAllPartners: false,
    enabledText: 'ENABLED',
    disabledText: 'DISABLED PARTNERS',
    showAddPartner: false
  };

  componentDidUpdate() {
    if (this.props.scrollTop) {
      // $FlowFixMe
      ReactDOM.findDOMNode(this).scrollTop = 0;
    }
  }

  renderCards = (partners: Array<AdPartner>, enabled: boolean) => {
    const activePartners = partners.filter(partner => {
      return this.props.showAllPartners || isAdPartnerVisible(partner);
    });

    const partnersToDisplay = activePartners.filter((partner: AdPartner) => {
      const ingestionEnabled = R.path(['ingestion', 'enabled'], partner);
      if (ingestionEnabled) {
        return ingestionEnabled === enabled;
      }
      return !!partner.enabled === enabled;
    });

    return partnersToDisplay.map((partner: AdPartner, i: number) => {
      return (
        <PartnerCard
          accessResources={this.props.accessResources}
          permission={this.props.permission}
          onClick={this.props.onClick.bind(null, partner)}
          partner={partner}
          selectedPartner={this.props.selectedPartner}
          key={partner.machine_name}
          index={i}
        />
      );
    });
  };

  renderLoadingCards = () => {
    return new Array(13).fill(0).map((_, index) => {
      return (
        <div key={index} className="animated-background">
          <div
            className={classNames('animation-cover', {
              highlight: index % 2 === 0
            })}
          />
        </div>
      );
    });
  };

  render() {
    const partners = this.props.data;
    const { enabledText, disabledText } = this.props;
    return (
      <div className="partner-list">
        {this.props.loading ? (
          this.renderLoadingCards()
        ) : (
          <div>
            <div className="partner-list__header">
              <span className="partner-list__header-text">{enabledText}</span>
            </div>
            <div className="h_mb-40" data-testid="enabled-cards">
              {this.renderCards(partners, true) || (
                <div className="h_p-20" key={1} />
              )}
            </div>
            <div className="partner-list__header">
              <span className="partner-list__header-text">{disabledText}</span>
            </div>
            {this.props.showAddPartner ? (
              <AccessIconButton
                type="dashed"
                accessResources={[CHANNEL_LEVEL_SETTINGS]}
                permission={WRITE_PERMISSION}
                className="add-partner__add-custom-partner"
                containerClassName="h_w-100 add-partner__add-custom-partner-wrapper"
                testid="create-internal-partner"
                to="/ads/partner-management?modal=internal-partner"
              >
                Add Custom Partner
              </AccessIconButton>
            ) : null}
            <div data-testid="disabled-cards">
              {this.renderCards(partners, false)}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default PartnerList;
